	@defer (hydrate on immediate) {
	<div class="flex flex-col">
		<div class="relative">
			<div class="relative w-full z-[-999]">
				<img src="/assets/images/club/club_header.avif" class="w-full h-[600px] xl:h-[800px] z-[-999] object-cover" alt="Background club" />
			</div>
			<div class="relative justify-center w-8/12 mx-auto">

				<div class="absolute flex flex-row gap-10 justify-start w-fit -bottom-20 md:-bottom-30">

					<div class="flex flex-col text-peps-dark-200">
						<div class="uppercase flex flex-col text-[66px] sm:text-7xl md:text-[142px] lg:text-[152px] leading-16 sm:leading-20 md:leading-30 lg:leading-32 text-right">
							<span class="uppercase">{{ 'page.club.big-text.more' | translate }}</span>
							<span class="uppercase">{{ 'page.club.big-text.than' | translate }}</span>
							<div class="relative">
								<span class="uppercase">{{ 'page.club.big-text.club' | translate }}</span>
								<span class="absolute">.</span>
							</div>
							<span class="uppercase">{{ 'page.club.big-text.a' | translate }}</span>
							<div class="relative">
								<span class="uppercase">{{ 'page.club.big-text.commu' | translate }}</span>
								<span class="absolute">.</span>
							</div>
						</div>
					</div>

				</div>
			</div>
			<peps-separator></peps-separator>

		</div>
		<div class="flex flex-col gap-10 mb-10">

			<div class="snap-start shrink-0">

				<div class="flex flex-col lg:flex-row justify-center items-center pt-22 md:mx-20 3xl:mx-0">
					<div class="relative group
						w-full h-[459px] -translate-x-1
						xs:w-[438px] xs:h-[499px] xs:-translate-x-3
						sm:w-[503px] sm:h-[573px] sm:-translate-x-0
						lg:w-[600px] lg:h-[573px]
					">
						<div
							class="bg-[url(/assets/images/club/club_team_peps.avif)] relative z-10 w-full h-full bg-cover bg-center clip-shape-foreground transition-all duration-[2000ms] ease-in-out group-hover:scale-105 group-hover:-rotate-5 group-hover:brightness-100"
						></div>
						<img src="/assets/images/partners/partner_even_background.avif" alt=""
							 class="transition-all transform duration-[2000ms] absolute top-0 z-[-999] scale-[102%] w-full h-full ease-in-out group-hover:brightness-200 group-hover:-rotate-6 group-hover:translate-y-8 group-hover:-translate-x-3 translate-y-4 translate-x-0.5" />
					</div>
					<div class="flex flex-col gap-8 -translate-y-5 pt-10 px-8 lg:w-2/4 xl:w-2/5">
						<!--<span class="uppercase text-[32px]">{{ 'page.club.subtitle' | translate }}</span>-->
						<p class="text-justify font-notosans">{{ 'page.club.description' | translate }}</p>

						<div class="flex flex-row gap-2">
								<a href="https://www.tiktok.com/@teampepsmax" target="_blank">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z" fill="#F9ECEA"/>
									</svg>
								</a>
								<a href="https://www.twitch.tv/teampepsmax" target="_blank">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M6.00056 0L1.71484 4.28571V19.7143H6.8577V24L11.1434 19.7143H14.572L22.2863 12V0H6.00056ZM20.572 11.1429L17.1434 14.5714H13.7148L10.7148 17.5714V14.5714H6.8577V1.71429H20.572V11.1429Z" fill="#F9ECEA"/>
										<path d="M18.0004 4.71387H16.2861V9.85672H18.0004V4.71387Z" fill="#F9ECEA"/>
										<path d="M13.2866 4.71387H11.5723V9.85672H13.2866V4.71387Z" fill="#F9ECEA"/>
									</svg>
								</a>
								<a href="https://www.youtube.com/@TeamPepsMAX" target="_blank">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M23.7609 7.1998C23.7609 7.1998 23.5266 5.54512 22.8047 4.81855C21.8906 3.8623 20.8688 3.85762 20.4 3.80137C17.0438 3.55762 12.0047 3.55762 12.0047 3.55762H11.9953C11.9953 3.55762 6.95625 3.55762 3.6 3.80137C3.13125 3.85762 2.10938 3.8623 1.19531 4.81855C0.473438 5.54512 0.24375 7.1998 0.24375 7.1998C0.24375 7.1998 0 9.14512 0 11.0857V12.9045C0 14.8451 0.239062 16.7904 0.239062 16.7904C0.239062 16.7904 0.473437 18.4451 1.19062 19.1717C2.10469 20.1279 3.30469 20.0951 3.83906 20.1982C5.76094 20.3811 12 20.4373 12 20.4373C12 20.4373 17.0438 20.4279 20.4 20.1889C20.8688 20.1326 21.8906 20.1279 22.8047 19.1717C23.5266 18.4451 23.7609 16.7904 23.7609 16.7904C23.7609 16.7904 24 14.8498 24 12.9045V11.0857C24 9.14512 23.7609 7.1998 23.7609 7.1998ZM9.52031 15.1123V8.36699L16.0031 11.7514L9.52031 15.1123Z" fill="#F9ECEA"/>
									</svg>
								</a>
								<a href="https://www.x.com/TeamPepsMAX" target="_blank">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M18.3263 1.9043H21.6998L14.3297 10.3278L23 21.7903H16.2112L10.894 14.8383L4.80995 21.7903H1.43443L9.31743 12.7804L1 1.9043H7.96111L12.7674 8.25863L18.3263 1.9043ZM17.1423 19.7711H19.0116L6.94539 3.81743H4.93946L17.1423 19.7711Z" fill="#F9ECEA"/>
									</svg>
								</a>
								<a href="https://www.instagram.com/teampepsmaxx" target="_blank">
									<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="24" height="24">
										<path d="M7 2C4.239 2 2 4.239 2 7v10c0 2.761 2.239 5 5 5h10c2.761 0 5-2.239 5-5V7c0-2.761-2.239-5-5-5H7zm0 2h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zm10 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/>
									</svg>
								</a>
						</div>
					</div>
				</div>
			</div>
			<div class="w-full flex flex-row justify-center">
				<div class="flex flex-col">
					<span class="text-7xl xs:text-8xl sm:text-9xl md:text-[200px]">1 800 000</span>
					<div class="relative">
						<div class="absolute flex flex-row gap-1 items-end -bottom-5 md:-bottom-8">
							<span class="uppercase text-base xs:text-2xl sm:text-3xl md:text-5xl">{{ 'page.club.viewers-text' | translate }}</span>
							<img src="/assets/gifs/PEPS_flagbig.gif" alt="GIF peps big flag" class="h-14 xs:h-16 sm:h-20 md:h-32">
						</div>
					</div>
				</div>
			</div>

			<span class="flex flex-row justify-center px-8 w-full md:w-6/12 mx-auto font-notosans text-justify mt-20">
				{{ 'page.club.second-description' | translate }}
			</span>

			<div>

				<div class="relative">

					<div
						class="relative w-full overflow-hidden"
						(touchstart)="handleTouchStart($event)"
						(touchmove)="handleTouchMove($event)"
						(touchend)="handleTouchEnd($event)"
					>
						<div
							#sliderTrack
							class="flex transition-transform duration-500 ease-in-out h-[400px] sm:h-[500px] lg:h-[700px] pl-[60px] md:pl-[208px] w-full "
						>
							@for (gallery of galleries; track gallery.id; let i = $index; let last = $last; let first = $first) {

								<div
									class="relative flex-shrink-0 w-full h-full flex items-center justify-center"
									[ngStyle]="{ transform: 'translateX(-' + (i * 32) + 'px)' }"
								>

									<img
										[src]="minioBaseUrl + gallery.thumbnailImageKey"
										[alt]="gallery.translations.fr.eventName"
										class="w-full h-full object-cover"
										[ngClass]="{'clip-shape-slide-last': last, 'clip-shape-slide': !last}"
									/>

									<div
										class="absolute flex flex-col gap-4 items-center justify-center w-fit mx-auto bottom-20"
									>
										<div class="flex flex-col items-center text-center">
											<span class="text-2xl md:text-3xl lg:text-4xl font-bold uppercase text-outline">{{ gallery.translations[translateDynamicService.getLang()].eventName }}</span>
											<span class="text-lg md:text-xl lg:text-2xl font-medium text-outline">{{ gallery.date | localizedDate: 'dd/MM/yyyy' }}</span>
										</div>

										<peps-button
											[text]="'page.club.view-gallery' | translate"
											[link]="'/gallery/' + gallery.id"
										></peps-button>
									</div>

									@if((!last && !first) || (last && !first)) {
										<img src="assets/images/club/club_slide_separator.svg" alt="" class="absolute z-[999] top-0 left-0 h-full hidden lg:block -translate-x-5">
									}
								</div>

							}
						</div>


						<button
							class="absolute left-10 top-1/2 -translate-y-1/2 z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer p-1.5 md:p-2.5 text-peps-dark-700"
							(click)="prevSlide()"
						>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 md:size-6 3xl:size-9">
								<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
							</svg>
						</button>

						<button
							class="absolute right-10 top-1/2 -translate-y-1/2 z-10 bg-peps-gold hover:bg-peps-yellow cursor-pointer p-1.5 md:p-2.5 text-peps-dark-700"
							(click)="nextSlide()"
						>
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 md:size-6 3xl:size-9">
								<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
							</svg>
						</button>
					</div>

					<img src="/assets/images/cross.avif" alt="Peps cross" class="absolute left-10 md:left-20 -bottom-10 z-[-5] pointer-events-none">
				</div>

				<div class="flex flex-row justify-around -translate-y-10 flex-wrap md:flex-nowrap gap-12 px-8">
					<div class="flex flex-col leading-[45px] sm:leading-[110px] text-peps-dark-200 z-10">
						<div class="flex flex-row justify-end">
							<span class="text-6xl lg:text-8xl xl:text-9xl 2xl:text-[152px]">3.5M</span>
							<span class="invisible w-9 md:w-13"></span>
						</div>

						<div class="flex flex-row items-center leading-[20px] md:leading-normal gap-2">
							<span class="text-[32px] lg:text-[52px] xl:text-[62px] 2xl:-[72px] uppercase">{{ 'page.club.stats.views-live' | translate }}</span>
							<div class="flex flex-row gap-2">
								<svg class="w-8 h-8 md:w-10 md:h-10" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12.0011 0L3.42969 8.57143V39.4286H13.7154V48L22.2868 39.4286H29.144L44.5725 24V0H12.0011ZM41.144 22.2857L34.2868 29.1429H27.4297L21.4297 35.1429V29.1429H13.7154V3.42857H41.144V22.2857Z" fill="#F9ECEA"/>
									<path d="M36.0018 9.42871H32.5732V19.7144H36.0018V9.42871Z" fill="#F9ECEA"/>
									<path d="M26.5731 9.42871H23.1445V19.7144H26.5731V9.42871Z" fill="#F9ECEA"/>
								</svg>
							</div>

						</div>
					</div>

					<div class="flex flex-col leading-[45px] sm:leading-[110px] text-peps-dark-200 z-10">
						<div class="flex flex-row justify-end">
							<span class="text-6xl lg:text-8xl xl:text-9xl 2xl:text-[152px]">30M</span>
							<span class="invisible w-9 md:w-13"></span>
						</div>

						<div class="flex flex-row items-center leading-[20px] md:leading-normal gap-2">
							<span class="text-[32px] lg:text-[52px] xl:text-[62px] 2xl:-[72px] uppercase">{{ 'page.club.stats.impressions' | translate }}</span>
							<div class="flex flex-row gap-2 items-center">
								<svg class="w-8 h-8 md:w-10 md:h-10" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M36.6526 3.80762H43.3995L28.6594 20.6546L46 43.5796H32.4225L21.7881 29.6757L9.61989 43.5796H2.86886L18.6349 25.5598L2 3.80762H15.9222L25.5348 16.5163L36.6526 3.80762ZM34.2846 39.5412H38.0232L13.8908 7.63388H9.87892L34.2846 39.5412Z" fill="#F9ECEA"/>
								</svg>
								<svg class="w-6 h-6 sm:w-12 sm:h-12" xmlns="http://www.w3.org/2000/svg" fill="#F9ECEA" viewBox="0 0 24 24" width="48" height="48">
									<path d="M7 2C4.239 2 2 4.239 2 7v10c0 2.761 2.239 5 5 5h10c2.761 0 5-2.239 5-5V7c0-2.761-2.239-5-5-5H7zm0 2h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zm10 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/>
								</svg>
							</div>

						</div>
					</div>
					<div class="flex flex-col leading-[45px] sm:leading-[110px] text-peps-dark-200 z-10">
						<div class="flex flex-row justify-end">
							<span class="text-6xl lg:text-8xl xl:text-9xl 2xl:text-[152px]">66M</span>
						</div>

						<div class="flex flex-row items-center leading-[20px] md:leading-normal gap-2">
							<span class="text-[32px] lg:text-[52px] xl:text-[62px] 2xl:-[72px] uppercase">{{ 'page.club.stats.views-video' | translate }}</span>
							<div class="flex flex-row gap-2">
								<svg class="w-8 h-8 md:w-10 md:h-10" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1315 25.7391 18.8651 25.6V17.3913C10.6374 17.5304 4 24.2783 4 32.6956C4 41.1827 10.7757 48 19.1417 48C27.5075 48 34.2833 41.1131 34.2833 32.6956V15.9304C37.3255 18.1565 41.059 19.4783 45 19.5479V11.3391C38.9157 11.1304 34.1451 6.12173 34.1451 0Z" fill="#F9ECEA"/>
								</svg>
								<svg class="w-8 h-8 md:w-10 md:h-10" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M47.5219 14.3996C47.5219 14.3996 47.0531 11.0902 45.6094 9.63711C43.7812 7.72461 41.7375 7.71523 40.8 7.60273C34.0875 7.11523 24.0094 7.11523 24.0094 7.11523H23.9906C23.9906 7.11523 13.9125 7.11523 7.2 7.60273C6.2625 7.71523 4.21875 7.72461 2.39062 9.63711C0.946875 11.0902 0.4875 14.3996 0.4875 14.3996C0.4875 14.3996 0 18.2902 0 22.1715V25.809C0 29.6902 0.478125 33.5809 0.478125 33.5809C0.478125 33.5809 0.946875 36.8902 2.38125 38.3434C4.20937 40.2559 6.60938 40.1902 7.67813 40.3965C11.5219 40.7621 24 40.8746 24 40.8746C24 40.8746 34.0875 40.8559 40.8 40.3777C41.7375 40.2652 43.7812 40.2559 45.6094 38.3434C47.0531 36.8902 47.5219 33.5809 47.5219 33.5809C47.5219 33.5809 48 29.6996 48 25.809V22.1715C48 18.2902 47.5219 14.3996 47.5219 14.3996ZM19.0406 30.2246V16.734L32.0062 23.5027L19.0406 30.2246Z" fill="#F9ECEA"/>
								</svg>
							</div>

						</div>
					</div>

				</div>

			</div>
			<div class="mx-auto flex flex-col md:flex-row gap-8 justify-center items-center">
				<peps-button-small
					[text]="'page.club.become-partner' | translate"
					[link]="'/partners'"
				></peps-button-small>
				<peps-button
					[text]="'page.club.support-team-peps' | translate"
					[hrefLink]="'https://fr.tipeee.com/teampeps'"
				></peps-button>

			</div>

			<div class="flex flex-col items-center gap-4 my-10 bg-peps-dark-700 border border-peps-dark-600 mx-auto p-8 w-10/12 md:w-9/12 2xl:w-6/12">
				<span class="uppercase text-[32px] text-peps-gold text-wrap text-center">{{ 'page.club.legends.title' | translate }}</span>

				<p class="text-center font-notosans text-lg">
					@for (legend of legends; track legend; let idx = $index) {
						{{ legend }} @if (idx < legends.length - 1) { - }
					}
				</p>

				<peps-button-small
					[text]="'page.club.legends.join-them' | translate"
					[hrefLink]="'https://fr.tipeee.com/teampeps'"
				></peps-button-small>
			</div>
		</div>
		<peps-last-videos></peps-last-videos>

	</div>
	<peps-emote-scene-v2></peps-emote-scene-v2>
}
<!--
<peps-emotes-scene
	[users]="legendsEmotes"
></peps-emotes-scene>
-->
